<footer><div class="copy">© Übikiri,<span>2019 - 2023</span></div><!--.linksa(href="#") About
a(href='#') Advertising
a(href="#") Developers--><!--.langspan Language
button([matMenuTriggerFor]='footer_lang')
  | English
  mat-icon keyboard_arrow_down
mat-menu(#footer_lang='matMenu')
  button(mat-menu-item='') English
  button(mat-menu-item='') Russian--></footer>